export const perfomanceDates = [
  {label: '15.06', value: '06-15'},
  {label: '16.06', value: '06-16'},
  {label: '17.06', value: '06-17'},
  {label: '18.06', value: '06-18'},
  {label: '19.06', value: '06-19'},
  {label: '20.06', value: '06-20'}
]
// формат ММ-ДД

export const timelineDays = ['06-15','06-16', '06-17', '06-18', '06-19', '06-20']